export function getCountDisplayedValue(count: number, maxNumber: number = 99): string {
  return `${count > maxNumber ? `${maxNumber}+` : count}`;
}
